import Hitmontop from './src/Hitmontop.js';

class MainController {
  
  constructor(container){
    this.container = container;
    
    // Setup the scene:
    const scene = new Hitmontop();
    scene.element.style.display = "none"
    
    container.appendChild(scene.element);
    
    this.scene = scene;
    
    // Setup loading:    
    const loadingElement = document.createElement("span");
    loadingElement.textContent = "Preparing…";
    
    // Audio:
    const audioPlayer = document.getElementsByTagName("audio")[0];
    audioPlayer.addEventListener("play", () => {
      loadingElement.parentNode.removeChild(loadingElement);
      
      scene.element.classList.add("cue-in");
      scene.element.style.display = "block";
      
      document.title = "</3";
    })
    
    // Button:
    const button = document.createElement("button");
    button.textContent = "Trust me again";
    button.addEventListener("click", (event) => {
      // Remove button:
      button.parentNode.removeChild(button);
      
      // Add loading:
      container.appendChild(loadingElement);
      
      // Trigger playback:
      audioPlayer.play();
      
      // Trigger video playback:
      scene.play();
    })
    
    container.appendChild(button)
  }
  
}

function awake(){
  window.controller = new MainController(document.body);
}

document.addEventListener("DOMContentLoaded", awake);
